import { useFormik } from "formik"
import * as Yup from "yup"
import React from "react"
import {
  Card,
  CardBody,
  Label,
  Button,
  Form,
  Input,
  FormFeedback,
} from "reactstrap"
import CustomHeaderTitle from "components/Common/CustomHeaderTitle"
import SingleSelect from "components/Common/SelectBoxes/SingleSelect"

const FundCodeForm = ({ onSubmit, loading, error, formMode, fundCode }) => {
  const validationType = useFormik({
    enableReinitialize: true,
    initialValues: {
      code: fundCode ? fundCode?.code : "",
      name: fundCode ? fundCode?.name : "",
      status: fundCode ? fundCode?.status : "",
    },
    validationSchema: Yup.object().shape({
      code: Yup.string().required("This code is required"),
      name: Yup.string().required("This name is required").min(3),
      status: Yup.string().required("This status is required"),
    }),
    onSubmit: values => {
      onSubmit(values)
    },
  })

  return (
    <Card>
      <CardBody>
        <CustomHeaderTitle
          loading={loading}
          title={formMode === "Edit" ? "Edit Fund Code" : "Add Fund Code"}
          lgColumn={3}
          rowCount={false}
          orderingList={false}
          searchBox={false}
          rightBtn={true}
          rightBtnTitle={"Back"}
          rightBtnRoute={"/fund-codes"}
        />

        <Form
          onSubmit={e => {
            e.preventDefault()
            validationType.handleSubmit()
            return false
          }}
        >
          <div className="mb-3">
            <Label className="form-label">Code</Label>
            <Input
              name="code"
              placeholder="Code"
              type="text"
              onChange={validationType.handleChange}
              onBlur={validationType.handleBlur}
              value={validationType.values.code || ""}
              invalid={
                (validationType.touched.code && validationType.errors.code) ||
                error?.code?.[0]
                  ? true
                  : false
              }
            />
            {(validationType.touched.code && validationType.errors.code) ||
            error?.code?.[0] ? (
              <FormFeedback type="invalid">
                {validationType.errors.code || error?.code?.[0]}
              </FormFeedback>
            ) : null}
          </div>

          <div className="mb-3">
            <Label className="form-label">Name</Label>
            <Input
              name="name"
              placeholder="Name"
              type="text"
              onChange={validationType.handleChange}
              onBlur={validationType.handleBlur}
              value={validationType.values.name || ""}
              invalid={
                (validationType.touched.name && validationType.errors.name) ||
                error?.name?.[0]
                  ? true
                  : false
              }
            />
            {(validationType.touched.name && validationType.errors.name) ||
            error?.name?.[0] ? (
              <FormFeedback type="invalid">
                {validationType.errors.name || error?.name?.[0]}
              </FormFeedback>
            ) : null}
          </div>

          <div className="mb-3">
            <Label className="form-label">Status</Label>
            <SingleSelect
              defaultValue={fundCode?.status}
              name="status"
              options={[
                { value: "Active", label: "Active" },
                { value: "Deactive", label: "Deactive" },
              ]}
              formik={validationType}
              formMode={formMode}
            />
            {(validationType.touched.status && validationType.errors.status) ||
            error?.status?.[0] ? (
              <FormFeedback type="invalid">
                {validationType.errors.status || error?.status?.[0]}
              </FormFeedback>
            ) : null}
          </div>

          <div className="d-flex flex-wrap gap-2">
            <Button type="submit" color="primary" disabled={loading}>
              {loading
                ? "Please Wait..."
                : formMode === "Add"
                ? "Submit"
                : "Update"}
            </Button>
          </div>
        </Form>
      </CardBody>
    </Card>
  )
}

export default FundCodeForm
